import { render } from "./ChallengeGenerator.vue?vue&type=template&id=6a56a6ba&scoped=true"
import script from "./ChallengeGenerator.vue?vue&type=script&lang=js"
export * from "./ChallengeGenerator.vue?vue&type=script&lang=js"

import "./ChallengeGenerator.vue?vue&type=style&index=0&id=6a56a6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a56a6ba"]])

export default __exports__